import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { NotificationManager } from '../../components/common/react-notifications';
import {
    TASK_VEHICLE_LIST,
    TASK_VEHICLE_ADD,
    TASK_VEHICLE_UPDATE
} from '../actions';
import {
    TaskVehicleListSuccess,
    TaskVehicleListError,
    TaskVehicleAddSuccess,
    TaskVehicleAddError,
    TaskVehicleUpdateSuccess,
    TaskVehicleUpdateError
} from '../actions';

function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

// LIST
const onTaskVehicleListAsync = async (payload) => {
    const token = await getToken(authFB);
    const response = await fetch(servicePath + 'task_vehicle/list', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(res => res.json()).catch(err => console.log(err));
    return { data: response };
};

function* onTaskVehicleList(action) {
    try {
        const response = yield call(onTaskVehicleListAsync, action.payload);
        yield put(TaskVehicleListSuccess(response.data.data));
    } catch (error) {
        yield put(TaskVehicleListError(error));
    }
}

// ADD
const onTaskVehicleAddAsync = async (payload) => {
    const token = await getToken(authFB);
    const response = await fetch(servicePath + 'task_vehicle/add', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(res => res.json()).catch(err => console.log(err));
    return { data: response };
};

function* onTaskVehicleAdd(action) {
    try {
        const response = yield call(onTaskVehicleAddAsync, action.payload);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else {
            NotificationManager.error(response.data.message || 'Error', 'Error', 3000, null, null, '');
        }
        yield put(TaskVehicleAddSuccess(response.data.id));
    } catch (error) {
        yield put(TaskVehicleAddError(error));
        NotificationManager.error('Error al agregar vehículo a la tarea', 'Error', 3000, null, null, '');
    }
}

// UPDATE
const onTaskVehicleUpdateAsync = async (payload) => {
    const token = await getToken(authFB);
    const response = await fetch(servicePath + 'task_vehicle/update', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(res => res.json()).catch(err => console.log(err));
    return { data: response };
};

function* onTaskVehicleUpdate(action) {
    try {
        const response = yield call(onTaskVehicleUpdateAsync, action.payload);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else {
            NotificationManager.error(response.data.message || 'Error', 'Error', 3000, null, null, '');
        }
        yield put(TaskVehicleUpdateSuccess(response.data));
    } catch (error) {
        yield put(TaskVehicleUpdateError(error));
        NotificationManager.error('Error al actualizar vehículo de la tarea', 'Error', 3000, null, null, '');
    }
}

function* watchTaskVehicleList() { yield takeEvery(TASK_VEHICLE_LIST, onTaskVehicleList); }
function* watchTaskVehicleAdd() { yield takeEvery(TASK_VEHICLE_ADD, onTaskVehicleAdd); }
function* watchTaskVehicleUpdate() { yield takeEvery(TASK_VEHICLE_UPDATE, onTaskVehicleUpdate); }

export default function* rootSaga() {
    yield all([
        fork(watchTaskVehicleList),
        fork(watchTaskVehicleAdd),
        fork(watchTaskVehicleUpdate)
    ]);
}
